import isString from 'lodash/isString';

// eslint-disable-next-line import/prefer-default-export,consistent-return
export const checkASCII = (value) => {
  if (isString(value)) {
    // eslint-disable-next-line no-control-regex
    return /^[\x00-\x7F]*$/.test(value);
  }
};
